import { OutlinedInput } from "@mui/material";
import React, { ComponentProps } from "react";

import { useFieldContext } from "src/hooks";

import { FormControl } from "../FormControl";

type Props = ComponentProps<typeof FormControl> & {
  placeholder?: string;
  autoComplete?: string;
};

export const TextField = ({ placeholder, autoComplete, label }: Props) => {
  const field = useFieldContext<string>();

  return (
    <FormControl label={label}>
      <OutlinedInput
        id={field.name}
        label={label}
        placeholder={placeholder}
        autoComplete={autoComplete}
        error={field.state.meta.errors?.length > 0}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
      />
    </FormControl>
  );
};
